import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * useAuth — single source of truth for the current user.
 * States: user === undefined (loading), null (not authenticated), object (authed).
 */
export function useAuth({ skipInitial = false } = {}) {
  const [user, setUser] = useState(undefined);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (_) {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    if (skipInitial) return;
    // If returning from OAuth (hash contains session_id), skip — AuthCallback will handle.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      return;
    }
    checkAuth();
  }, [checkAuth, skipInitial]);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (_) {
      /* noop */
    }
    setUser(null);
  }, []);

  return { user, setUser, checkAuth, logout };
}
